import { Text } from '@chakra-ui/react';
import { BackofficeActivitiesOrderItem } from '@diamond/shared/types';

import { useQuantityFormat } from '../../../hooks/use-quantity-format';
import { ColumnComponentProps } from '../../../types/activity-column-types';

export function DeliveredQuantityColumn({
  info,
}: ColumnComponentProps<BackofficeActivitiesOrderItem, number | null | undefined>) {
  const { quantity } = useQuantityFormat(info.row.original, Number(info.getValue()));

  if (info.getValue() !== 0) {
    return <Text fontSize="sm" fontWeight="400">{quantity}</Text>;
  }

  return <Text fontSize="sm" fontWeight="400">{info.getValue() ?? '-'}</Text>;
}
